import React, { useCallback } from 'react';
import Placeholder from './placeholder.svg';
import { useDeviceSize } from '@vmos2/providers';

import { IconButton } from '../buttons';
import { ListCard } from '../ListCard/ListCard';
import { withSpacingStyles } from '../withSpacingStyles';

type Props = {
  isActive: boolean,
  emptyTitle: string,
  name: string,
  uuid: string,
  footerRight?: React.Node,
  hasImage: boolean,
  imageSrc?: ?string,
  price?: React.Node,
  handleSetItem: Function,
  handleRemoveItem: Function,
  mode?: string,
  className: ?string,
  dataTest?: string,
  content?: React.Node,
  label?: string,
  labelMode?: string,
  disabled?: boolean,
};

export const ToggleCard = withSpacingStyles(
  ({
    isActive,
    emptyTitle,
    name,
    uuid,
    footerRight,
    hasImage,
    imageSrc,
    price,
    handleSetItem,
    handleRemoveItem,
    mode = 'MealCard',
    className,
    dataTest,
    content,
    label,
    labelMode,
    disabled,
  }: Props) => {
    const { isMobile } = useDeviceSize();

    const setItem = useCallback(
      e => {
        e.preventDefault();
        e.stopPropagation();
        return !isActive && handleSetItem();
      },
      [isActive, handleSetItem]
    );

    const removeItem = useCallback(
      e => {
        e.preventDefault();
        e.stopPropagation();
        return handleRemoveItem();
      },
      [handleRemoveItem]
    );

    return (
      <ListCard
        className={className}
        emptyTitle={!isActive && emptyTitle}
        name={name}
        uuid={uuid}
        imageSrc={imageSrc}
        footerLeft={price}
        footerRight={footerRight}
        isEmpty={!isActive}
        hasImage={hasImage}
        onClick={setItem}
        placeholder={Placeholder}
        mode={mode}
        dataTest={dataTest}
        content={content}
        label={label}
        labelMode={labelMode}
        disabled={disabled}
      >
        {isActive && (
          <IconButton
            data-test="toggle-remove-button"
            icon="Trash"
            onClick={removeItem}
            size={isMobile ? 'xsmall' : 'small'}
            mode="light"
          />
        )}
      </ListCard>
    );
  }
);

ToggleCard.defaultProps = {
  hasImage: false,
  className: null,
};
